module.exports = __webpack_public_path__ + "img/menu_gh7e0e.ce8a95f8.svg";